import { render, staticRenderFns } from "./EvaluatorAssignment.vue?vue&type=template&id=40607c38"
import script from "./EvaluatorAssignment.vue?vue&type=script&lang=js"
export * from "./EvaluatorAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40607c38')) {
      api.createRecord('40607c38', component.options)
    } else {
      api.reload('40607c38', component.options)
    }
    module.hot.accept("./EvaluatorAssignment.vue?vue&type=template&id=40607c38", function () {
      api.rerender('40607c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/EvaluatorAssignment.vue"
export default component.exports